import { isProductionEnvironment } from "../utils/environments";

export const shareholderCommitmentWhitelist = [
  "123456789", // Cloud ventures AS
  "998877665", // Cloud Manco AS
  "321654987", // Falk Global Demo
  "241364748", // Demo Fund I AS
  "932681625", // Startuplab Founders Fund V AS
];

export type FeatureToggle = "customDocument";

export type FeatureToggles = Partial<Record<FeatureToggle, boolean>>;

const featureToggles: Record<FeatureToggle, string[]> = {
  customDocument: [
    "123456789", // Cloud Ventures AS
    "321654987", // Falk Global Demo
    "241364748", // Demo Fund I AS

    // SPG companies
    "818545762", // SPG Bakke Bolig Skårer AS
    "818546262", // SPG Bakke Bolig Gressvik AS
    "819436592", // Spg Bolig Gressvik Holding AS
    "821833442", // Glittertinden Invest 3 AS
    "825172912", // SPG Omsorg 2 Holding AS
    "828967592", // Residev I Holding AS
    "829340372", // Brygga 18 SPG Holding AS
    "829694352", // Hotvetalleen SPG Holding AS
    "915796710", // Akka Invest 1 AS
    "918037772", // Bolig Rykkinn AS
    "918525270", // Skardstinden Invest 2 AS
    "918545786", // Spg Bolig Skårer Holding AS
    "918546189", // Kalkbyen Holding AS (tidl Spg Bakke Franzefossbyen Holding AS)
    "919436476", // Spg Omsorgsbygg AS
    "919436514", // Sentraltind Invest 6 AS
    "919436522", // Spg Franzefossbyen Holding AS
    "919436565", // Spg Gulskogen Stasjon AS
    "920139108", // Østerdalsgata 1 Prosjekt AS
    "920851401", // Spg Vekstbolig AS
    "921108648", // Spg Eiendom 21 AS
    "921116934", // Spg Bostad Strømstad Holding AS
    "921116985", // Spg Tangen AS
    "921117213", // S. Futurebuilt Prosjekt AS (tidl Spg Eiendom 26 AS )
    "921117221", // Spg Omsorgsbygg 2 AS
    "921117264", // Hotvetalleen Holding AS (tidl Spg Eiendom 25 AS)
    "921117272", // Kebnekaise Invest 4 AS
    "921833504", // Spg Omsorg Holding AS
    "921838840", // Nedre Eikervei 65 AS
    "921838875", // Dammensvika Eiendomsutvikling AS
    "921838883", // Spg Tangen Holding AS
    "921838905", // Residev I AS
    "921838913", // Eterfabrikken Utvikling AS
    "921838999", // Spg SAGA Prosjekt AS
    "923030999", // Galdhøpiggen Invest 5 AS
    "923067388", // Hedmarksgata Brl
    "923124055", // Hedmarksgata Holding AS
    "924056460", // Spg V146 AS
    "924295104", // Fjordbyen Lierstranda Utvikling AS
    "925175013", // Spg Gulskogen Stasjon Holding AS
    "925175935", // SPG Dammensvika Holding AS
    "925782939", // Hotvet Boligpark AS
    "926647245", // Ommen AS
    "926647342", // Finpool AS
    "928351394", // Brygga 20 AS
    "928967557", // Ankerhagen AS
    "928967662", // NEV 65 SPG HOLDING AS
    "929340418", // Brygga Hamar AS (tidl. Brygga 18 Holding AS)
    "929609522", // T27 Andeler AS
    "929674340", // S. Futurebuilt Utvikling AS (tidl SP Group I AS)
    "929674367", // S. FutureBuilt Prosjekt Holding AS
    "929694473", // Nedre Eikervei Holding AS
    "930508241", // Brygga 18 AS
    "932873818", // OB2 Prosjekt AS
    "934198255", // Ommen Leiligheter AS
    "934198271", // Ommen Småhus AS
    "940537851", // Slippen Eiendom AS
    "981603052", // Scandinavian Property Group AS
  ],
};

export const featureTogglesForCompany = (orgNo: string | undefined): FeatureToggles =>
  Object.fromEntries(
    Object.entries(featureToggles).map(([k, v]) => [
      k,
      !isProductionEnvironment() || (orgNo && v.includes(orgNo)),
    ]),
  ) as FeatureToggles;
